"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedYouTubeAdapter = void 0;
const demarked_1 = require("@d24/demarked");
const services_1 = require("../../../../services");
const adapter_1 = require("../../../_abstract/adapter");
const _contracts_1 = require("../../../_contracts");
const adapter_2 = require("../../../_helpers/adapter");
const Embed_contracts_1 = require("../../Embed.contracts");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
class EmbedYouTubeAdapter extends adapter_1.AbstractAdapter {
    /**
     * Adapts (translates/maps) the passed-in `EmbedModule` to the `EmbedYouTubeToken`.
     *
     * @param object - The module to adapt.
     */
    objectToToken(object) {
        const { content } = object;
        this.validate(content, {
            description: {
                type: 'string'
            },
            videoId: {
                presence: true,
                type: 'string',
                length: { minimum: 1 }
            }
        });
        if (typeof content.thumbnail !== 'undefined') {
            this.validate(content.thumbnail, {
                type: adapter_1.getRelatedTypeConstraint(services_1.RelatedType.File),
                value: adapter_1.getIdentifierConstraint()
            });
        }
        const { description, thumbnail, videoId } = content;
        let meta = {};
        let raw = `#YT[ videoId: ${videoId} ]`;
        if (typeof description === 'string') {
            meta = { ...meta, description };
            raw = raw.substring(0, raw.length - 1) + `| description: ${description} ]`;
        }
        if (typeof thumbnail !== 'undefined' && typeof thumbnail.value === 'number') {
            const thumbnailId = thumbnail.value;
            if (typeof thumbnailId === 'number') {
                meta = { ...meta, thumbnailId };
                raw = raw.substring(0, raw.length - 1) + `| thumbnailId: ${thumbnailId} ]`;
            }
        }
        const token = {
            content: videoId,
            raw,
            type: demarked_1.TokenType.EmbedYouTube
        };
        if (Object.keys(meta).length > 0) {
            token.meta = meta;
        }
        return token;
    }
    /**
     * Adapts (translates/maps) the passed-in `EmbedYouTubeToken` to the `EmbedModule`.
     *
     * @param token - The token to adapt.
     */
    tokenToObject(token) {
        this.validate(token, {
            content: {
                presence: true,
                type: 'string',
                length: { minimum: 1 }
            }
        });
        if (typeof token.meta !== 'undefined') {
            this.validate(token.meta, {
                description: {
                    type: 'string'
                },
                thumbnailId: {
                    type: 'number'
                }
            });
        }
        const { content: videoId, meta } = token;
        const object = {
            ...adapter_2.getModuleBase(),
            content: { videoId },
            driver: _contracts_1.ModuleDriver.Embed,
            version: Embed_contracts_1.EmbedVersion.YouTube
        };
        if (typeof meta !== 'undefined') {
            const { description, thumbnailId } = meta;
            if (typeof description === 'string') {
                object.content.description = description;
            }
            if (typeof thumbnailId === 'number') {
                object.content.thumbnail = {
                    type: services_1.RelatedType.File,
                    value: thumbnailId
                };
            }
        }
        object.content.type = Embed_contracts_1.EmbedVersion.YouTube;
        return object;
    }
}
exports.EmbedYouTubeAdapter = EmbedYouTubeAdapter;
//# sourceMappingURL=EmbedYouTube.adapter.js.map